import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tahun', 'kodeacc', 'namaacc', 'refreshsaldo'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }

                const url = `/coa${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    refreshStruktur(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`/coa/refreshstruktur?tahun=${obj.tahunBuku}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    tahunbuku() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get("/coa/tahunbuku");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    update(data) {
        return new Promise(async (resolve, reject) => {
            try {
                // const obj = { kodelama: data.kodelama, tahunlama: data.tahunlama, tahun: data.tahun, kodeacc: data.kodeacc, namaacc: data.namaacc, typeacc: data.typeacc, tanda_nrc: data.tanda_nrc, awal: data.awal };
                // await axios.put("coa", obj);
                await axios.put("coa", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    insert(data) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post("coa", data);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`coa/${obj.tahun}/${obj.kodeacc}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    print(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tahun', 'kodeacc', 'namaacc'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`/coa/print${str}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        });

    },

    exportXls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['tahun', 'kodeacc', 'namaacc'];

                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
        
               const resp = await axios({
                    url: `/coa/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                resolve(resp);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });                    
    }    
};